import { ExternalId } from './ExternalId'
export class Facility {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.name = params.name ? params.name : null
    this.timezone = params.timezone ? params.timezone : null
    this.editable = params.editable ? params.editable : null
    this.baseCurrency = params.baseCurrency ? params.baseCurrency : null
    this.baseCurrencyId = params.base_currency_id ? params.base_currency_id : null
    this.externalIds = params.external_ids ? params.external_ids.map((e) => new ExternalId(e)) : []
    this.defaultLanguageCode = params.default_language_code ? params.default_language_code : null
    this.allowedLanguageCodes = params.allowed_language_codes ? params.allowed_language_codes : null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      timezone: item.timezone,
      baseCurrencyId: item.baseCurrencyId,
    }
  }
}
